<div class="auth-login position-relative overflow-hidden d-flex align-items-center justify-content-center px-7 px-xxl-0 rounded-3 h-n20">
    <div class="position-relative w-100">
        <canvas id="hero-shader" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0;"></canvas>
        <div class="auth-login-wrapper card mb-0 container position-relative z-1 h-100 mh-n100" data-simplebar>
            <div class="card-body">
                <!--
                <a href="../main/index.html" class="">
                    <img src="../assets/images/logos/logo-dark.svg" class="light-logo" alt="Logo-Dark" />
                    <img src="../assets/images/logos/logo-light.svg" class="dark-logo" alt="Logo-light" />
                </a>
                -->
                <div class="row align-items-center justify-content-around pt-6 pb-5">
                    <div class="col-lg-6 col-xl-5 d-none d-lg-block">
                        <div class="text-center text-lg-start">
                            <img src="/assets/img/auth-logo.png" alt="spike-img" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-5">
                        <section data-id="register-form-container" style="display: block">
                            <img src="/assets/img/logo-horizontal.svg" alt="TmplVision" class="mb-4" style="max-width: 480px; height: auto;">
                            <p class="fs-4 mb-7" style="color: var(--bs-body-color);">Create your free account and start generating PDF and HTML documents in minutes.</p>
                            <!--
                            <div class="d-flex align-items-center gap-3">
                                <a class="btn btn-white w-100 text-dark border fw-bold d-flex align-items-center justify-content-center rounded-1 py-6 shadow-none" href="javascript:void(0)" role="button">
                                    <img src="../assets/images/svgs/google-icon.svg" alt="spike-img" class="img-fluid me-2" width="24" height="24">
                                    <span class="d-none d-sm-block me-1 flex-shrink-0">Sign in with</span>Google
                                </a>
                                <a class="btn btn-white w-100 text-dark border fw-bold d-flex align-items-center justify-content-center rounded-1 py-6 shadow-none" href="javascript:void(0)" role="button">
                                    <img src="../assets/images/svgs/icon-facebook.svg" alt="spike-img" class="img-fluid me-2" width="24" height="24">
                                    <span class="d-none d-sm-block me-1 flex-shrink-0">Sign in with</span>FB
                                </a>
                            </div>
                            <div class="position-relative text-center my-7">
                                <p class="mb-0 fs-3 px-3 d-inline-block bg-white z-1 position-relative">or sign in with</p>
                                <span class="border-top w-100 position-absolute top-50 start-50 translate-middle"></span>
                            </div>
                            -->
                            <form data-id="form-register">
                                <div class="mb-3">
                                    <label for="registerRegion"
                                           class="form-label fw-bold">Region</label>
                                    <small class="form-text text-muted d-block mb-2">This defines where your data is stored and processed.</small>
                                    <select class="form-select py-6"
                                            id="registerRegion"
                                            name="region"
                                            data-id="select-region"
                                            required>
                                        <option value="" disabled selected>Select your region</option>
                                        <option value="eu">Europe (EU)</option>
                                        <option value="us">United States (US)</option>
                                    </select>
                                </div>
                                <div class="mb-3">
                                    <label for="name"
                                           class="form-label fw-bold">Name</label>
                                    <input class="form-control py-6"
                                           id="name"
                                           name="name"
                                           type="text"
                                           placeholder=""
                                           aria-label="input name"
                                           required>
                                </div>
                                <div class="mb-3">
                                    <label for="email" class="form-label fw-bold">Email</label>
                                    <input type="email"
                                           class="form-control py-6"
                                           id="email"
                                           name="email"
                                           aria-describedby="emailHelp"
                                           required>
                                </div>
                                <div class="mb-9">
                                    <label for="inputPassword"
                                           class="form-label fw-bold">Password</label>
                                    <input type="password"
                                           class="form-control py-6"
                                           minlength="6"
                                           id="inputPassword"
                                           name="password"
                                           required>
                                </div>
                                <div class="mb-7 form-check">
                                    <input type="checkbox"
                                           class="form-check-input"
                                           id="acceptTerms"
                                           required>
                                    <label class="form-check-label fs-3" for="acceptTerms">
                                        I agree to the <a href="https://www.tmplvision.io/legal/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://www.tmplvision.io/legal/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                                    </label>
                                </div>
                                <button data-id="btn-register"
                                        type="button"
                                        class="btn btn-primary w-100 mb-7 rounded-pill">Sign Up</button>
                                <button data-id="btn-register-loading"
                                        class="btn btn-primary w-100 mb-7 rounded-pill"
                                        type="button"
                                        style="display: none;"
                                        disabled="">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...
                                </button>
                                <div data-id="register-error-container"
                                     class="invalid-feedback mb-3"></div>
                                <div class="d-flex align-items-center">
                                    <p class="fs-3 mb-0 fw-medium">Already have an Account?</p>
                                    <a class="text-primary fw-bold ms-2 fs-3" href="login">Sign In</a>
                                </div>
                                <p class="fs-2 mt-4 mb-0"><a class="text-muted" href="javascript:void(0)" data-open-cookie-settings>Cookie Settings</a></p>
                            </form>
                        </section>
                        <section data-id="register-success-container" style="display: none">
                            <h2 class="mb-6 fs-8 fw-bolder">Welcome aboard!</h2>
                            <p class="text-dark fs-4 mb-7">We’ve set up your account — now there’s just one last step.</p>
                            <p class="text-dark fs-4 mb-7">Check your inbox for a confirmation email and hit the link inside to activate your account.
                                (No email? Peek in your spam folder, just in case.)</p>
                            <p class="text-dark fs-4 mb-7">Once confirmed, you’ll be ready to roll with TmplVision.</p>
                            <a href="/login" class="btn btn-primary w-100 rounded-pill">
                                Back To The Login Form
                            </a>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="dark-transparent sidebartoggler"></div>
